import { get, set } from 'lodash';
import { ItemService } from '../';
export const transformKeyToArticleProp = async (response, dataItemsKey, itemProp) => {
    const dataItems = get(response, dataItemsKey);
    const itemIds = dataItems.map((dataItem) => Number(dataItem.key));
    const items = await ItemService.getBatch(itemIds);
    const transformedDataItems = dataItems.map((dataItem, index) => {
        const itemId = itemIds[index] || Number(dataItem.key);
        const item = items.find((item) => item.id === itemId);
        return {
            doc_count: dataItem.doc_count,
            key: get(item, itemProp) || dataItem.key,
            item,
        };
    });
    set(response, dataItemsKey, transformedDataItems);
    return response;
};
